/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehaviorFunctionModel } from '../../models/behavior-function-model';

export interface GetBehaviorFunctions$Params {
}

export function GetBehaviorFunctions(http: HttpClient, rootUrl: string, params?: GetBehaviorFunctions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BehaviorFunctionModel>>> {
  const rb = new RequestBuilder(rootUrl, GetBehaviorFunctions.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BehaviorFunctionModel>>;
    })
  );
}

GetBehaviorFunctions.PATH = '/api/Staff/GetBehaviorFunctions';
